import React, {
  useState,
  useEffect,
  useMemo,
  useContext,
} from "react";

import Alerta from "./Alertas";

import {
  db,
  auth,
} from "../firebase/firebaseConfig";

import {
  collection,
  getDocs,
  where,
  query,
  doc,
  getDoc,
  writeBatch,
  limit,
} from "firebase/firestore";

import { UserContext } from "../context/UserContext";

import ExportarExcel from "../funciones/ExportarExcel";

import {
  Table,
  Container,
  Segment,
  Input,
  Header,
  Form,
  Dropdown,
  Button,
  Icon,
} from "semantic-ui-react";

const CrearEquipos = () => {
  const user = auth.currentUser;
  const { users } = useContext(UserContext);

  // ==========================================================
  // ESTADOS MAESTROS
  // ==========================================================

  const [familia, setFamilia] = useState([]);

  const [nomFamilia, setNomFamilia] = useState(
    sessionStorage.getItem("familia") || ""
  );

  const [tipo, setTipo] = useState([]);

  const [nomTipo, setNomTipo] = useState(
    sessionStorage.getItem("tipo") || ""
  );

  const [marca, setMarca] = useState([]);

  const [nomMarca, setNomMarca] = useState(
    sessionStorage.getItem("marca") || ""
  );

  const [modelo, setModelo] = useState([]);

  const [nomModelo, setNomModelo] = useState(
    sessionStorage.getItem("modelo") || ""
  );

  const [serie, setSerie] = useState("");

  // ==========================================================
  // ALERTAS
  // ==========================================================

  const [alerta, cambiarAlerta] = useState({});
  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);

  // ==========================================================
  // EQUIPOS / UI
  // ==========================================================

  const [equipo, setEquipo] = useState([]);
  const [buscador, setBuscador] = useState("");
  const [flag, setFlag] = useState(false);

  const [isSaving, setIsSaving] = useState(false);

  const [empresaRut, setEmpresaRut] = useState("");

  // ==========================================================
  // UTILIDADES
  // ==========================================================

  const normalizarSerie = (valor) => {
    return String(valor || "")
      .trim()
      .toLocaleUpperCase();
  };

  // ==========================================================
  // OBTENER FAMILIAS
  // ==========================================================

  const getFamilia = async () => {
    if (!users?.emp_id) return;

    try {
      const qFamilias = query(
        collection(db, "familias"),
        where("emp_id", "==", users.emp_id),
        where("activo", "==", true)
      );

      const data = await getDocs(qFamilias);

      setFamilia(
        data.docs.map((d) => ({
          ...d.data(),
          id: d.id,
        }))
      );
    } catch (error) {
      console.error("Error obteniendo Familias:", error);
    }
  };

  // ==========================================================
  // OBTENER TIPOS
  // ==========================================================

  const getTipo = async () => {
    if (!users?.emp_id || !nomFamilia) {
      setTipo([]);
      return;
    }

    try {
      const qTipos = query(
        collection(db, "tipos"),
        where("emp_id", "==", users.emp_id),
        where("familia", "==", nomFamilia)
      );

      const data = await getDocs(qTipos);

      setTipo(
        data.docs.map((d) => ({
          ...d.data(),
          id: d.id,
        }))
      );
    } catch (error) {
      console.error("Error obteniendo Tipos:", error);
    }
  };

  // ==========================================================
  // OBTENER MARCAS
  // ==========================================================

  const getMarca = async () => {
    if (!users?.emp_id) return;

    try {
      const qMarcas = query(
        collection(db, "marcas"),
        where("emp_id", "==", users.emp_id)
      );

      const data = await getDocs(qMarcas);

      setMarca(
        data.docs.map((d) => ({
          ...d.data(),
          id: d.id,
        }))
      );
    } catch (error) {
      console.error("Error obteniendo Marcas:", error);
    }
  };

  // ==========================================================
  // OBTENER MODELOS
  // ==========================================================

  const getModelo = async () => {
    if (!users?.emp_id || !nomMarca) {
      setModelo([]);
      return;
    }

    try {
      const qModelos = query(
        collection(db, "modelos"),
        where("emp_id", "==", users.emp_id),
        where("marca", "==", nomMarca)
      );

      const data = await getDocs(qModelos);

      setModelo(
        data.docs.map((d) => ({
          ...d.data(),
          id: d.id,
        }))
      );
    } catch (error) {
      console.error("Error obteniendo Modelos:", error);
    }
  };

  // ==========================================================
  // OBTENER EMPRESA
  // ==========================================================

  const getEmpresa = async () => {
    if (!users?.emp_id) return;

    try {
      const empresaSnap = await getDoc(
        doc(db, "empresas", users.emp_id)
      );

      setEmpresaRut(
        empresaSnap.data()?.rut || ""
      );
    } catch (error) {
      console.error("Error obteniendo Empresa:", error);
    }
  };

  // ==========================================================
  // OBTENER EQUIPOS
  // ==========================================================

  const getEquipo = async () => {
    if (!users?.emp_id) return;

    try {
      const qEquipos = query(
        collection(db, "equipos"),
        where("emp_id", "==", users.emp_id)
      );

      const data = await getDocs(qEquipos);

      setEquipo(
        data.docs.map((d) => ({
          ...d.data(),
          id: d.id,
        }))
      );
    } catch (error) {
      console.error("Error obteniendo Equipos:", error);
    }
  };

  // ==========================================================
  // VALIDAR SERIE DIRECTAMENTE EN FIRESTORE
  // ==========================================================

  const verificarSerieFirestore = async (serieNormalizada) => {
    if (!users?.emp_id || !serieNormalizada) {
      return false;
    }

    const qSerie = query(
      collection(db, "equipos"),
      where("emp_id", "==", users.emp_id),
      where("serie", "==", serieNormalizada),
      limit(1)
    );

    const data = await getDocs(qSerie);

    return !data.empty;
  };

  // ==========================================================
  // CREAR EQUIPO + STATUS
  // ==========================================================

  const EquipoDb = async ({
    status,
    nomEntidad,
    familia,
    tipo,
    marca,
    modelo,
    serie,
    rfid,
    userAdd,
    userMod,
    fechaAdd,
    fechaMod,
    emp_id,
  }) => {
    const batch = writeBatch(db);

    /*
     * Generamos el ID antes de guardar.
     * El mismo ID se utiliza en equipos y status.
     */
    const equipoRef = doc(
      collection(db, "equipos")
    );

    const statusRef = doc(
      db,
      "status",
      equipoRef.id
    );

    // ========================================================
    // EQUIPO
    // ========================================================

    batch.set(equipoRef, {
      familia,
      tipo,
      marca,
      modelo,
      serie,
      rfid,

      useradd: userAdd,
      usermod: userMod,

      fechaadd: fechaAdd,
      fechamod: fechaMod,

      emp_id,
    });

    // ========================================================
    // STATUS
    // ========================================================

    batch.set(statusRef, {
      emp_id,

      familia,
      tipo,
      marca,
      modelo,

      status,

      serie,

      price: 0,

      tipoinout: "",

      r_origen: "",
      n_origen: "",

      r_destino: empresaRut,
      n_destino: nomEntidad,

      r_permanente: "",
      n_permanente: "",

      fecha_permanente: "",

      flag: true,

      useradd: userAdd,
      usermod: userMod,

      fechaadd: fechaAdd,
      fechamod: fechaMod,
    });

    await batch.commit();

    return equipoRef.id;
  };

  // ==========================================================
  // OPCIONES
  // ==========================================================

  const familiaOptions = useMemo(
    () =>
      [...familia]
        .sort((a, b) =>
          String(a.familia || "").localeCompare(
            String(b.familia || "")
          )
        )
        .map((d) => ({
          key: d.id,
          text: d.familia,
          value: d.familia,
        })),
    [familia]
  );

  const tipoOptions = useMemo(
    () =>
      [...tipo]
        .sort((a, b) =>
          String(a.tipo || "").localeCompare(
            String(b.tipo || "")
          )
        )
        .map((d) => ({
          key: d.id,
          text: d.tipo,
          value: d.tipo,
        })),
    [tipo]
  );

  const marcaOptions = useMemo(
    () =>
      [...marca]
        .sort((a, b) =>
          String(a.marca || "").localeCompare(
            String(b.marca || "")
          )
        )
        .map((d) => ({
          key: d.id,
          text: d.marca,
          value: d.marca,
        })),
    [marca]
  );

  const modeloOptions = useMemo(
    () =>
      [...modelo]
        .sort((a, b) =>
          String(a.modelo || "").localeCompare(
            String(b.modelo || "")
          )
        )
        .map((d) => ({
          key: d.id,
          text: d.modelo,
          value: d.modelo,
        })),
    [modelo]
  );

  // ==========================================================
  // ORDEN EQUIPOS
  // ==========================================================

  const orderedEquipo = useMemo(() => {
    const arr = [...equipo];

    arr.sort((a, b) => {
      const familiaA = String(a.familia || "");
      const familiaB = String(b.familia || "");

      const compareFamilia =
        familiaA.localeCompare(familiaB);

      if (compareFamilia !== 0) {
        return compareFamilia;
      }

      return String(a.tipo || "").localeCompare(
        String(b.tipo || "")
      );
    });

    return arr;
  }, [equipo]);

  // ==========================================================
  // BUSCADOR
  // ==========================================================

  const filteredEquipo = useMemo(() => {
    const q = buscador
      .toLowerCase()
      .trim();

    if (!q) {
      return orderedEquipo;
    }

    return orderedEquipo.filter((item) =>
      Object.keys(item).some((key) =>
        String(item[key] ?? "")
          .toLowerCase()
          .includes(q)
      )
    );
  }, [orderedEquipo, buscador]);

  // ==========================================================
  // DATOS GENERALES
  // ==========================================================

  useEffect(() => {
    if (!users?.emp_id) return;

    getFamilia();
    getMarca();
    getEmpresa();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users?.emp_id]);

  // ==========================================================
  // FAMILIA -> TIPO
  // ==========================================================

  useEffect(() => {
    getTipo();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users?.emp_id, nomFamilia]);

  // ==========================================================
  // MARCA -> MODELO
  // ==========================================================

  useEffect(() => {
    getModelo();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users?.emp_id, nomMarca]);

  // ==========================================================
  // EQUIPOS
  // ==========================================================

  useEffect(() => {
    getEquipo();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flag, users?.emp_id]);

  // ==========================================================
  // LIMPIAR SESSION AL SALIR
  // ==========================================================

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("familia");
      sessionStorage.removeItem("tipo");
      sessionStorage.removeItem("marca");
      sessionStorage.removeItem("modelo");
    };
  }, []);

  // ==========================================================
  // CAMBIO FAMILIA
  // ==========================================================

  const cambiarFamilia = (value) => {
    setNomFamilia(value);

    sessionStorage.setItem(
      "familia",
      value
    );

    /*
     * Si cambia Familia, el Tipo actual deja de ser válido.
     */
    setNomTipo("");
    setTipo([]);

    sessionStorage.removeItem(
      "tipo"
    );
  };

  // ==========================================================
  // CAMBIO MARCA
  // ==========================================================

  const cambiarMarca = (value) => {
    setNomMarca(value);

    sessionStorage.setItem(
      "marca",
      value
    );

    /*
     * Si cambia Marca, el Modelo actual deja de ser válido.
     */
    setNomModelo("");
    setModelo([]);

    sessionStorage.removeItem(
      "modelo"
    );
  };

  // ==========================================================
  // GUARDAR
  // ==========================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    if (isSaving) {
      return;
    }

    const ser = normalizarSerie(
      serie
    );

    // ========================================================
    // VALIDACIONES
    // ========================================================

    if (!nomFamilia) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje: "Favor seleccionar Familia.",
      });

      return;
    }

    if (!nomTipo) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Favor seleccionar Tipo de Equipamiento.",
      });

      return;
    }

    if (!nomMarca) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje: "Favor seleccionar Marca.",
      });

      return;
    }

    if (!nomModelo) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje: "Favor seleccionar Modelo.",
      });

      return;
    }

    if (!ser) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Favor ingresar N° de Serie.",
      });

      return;
    }

    // ========================================================
    // VALIDACIÓN LOCAL
    //
    // Es rápida y evita una consulta si ya sabemos
    // que la serie existe en la lista cargada.
    // ========================================================

    const existeSerieLocal = equipo.some(
      (equi) =>
        normalizarSerie(
          equi.serie
        ) === ser
    );

    if (existeSerieLocal) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Este número de serie ya se encuentra registrado.",
      });

      return;
    }

    setIsSaving(true);

    try {
      // ======================================================
      // VALIDACIÓN REAL EN FIRESTORE
      // ======================================================

      const existeSerieFirestore =
        await verificarSerieFirestore(
          ser
        );

      if (existeSerieFirestore) {
        cambiarEstadoAlerta(true);

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "Este número de serie ya se encuentra registrado.",
        });

        return;
      }

      // ======================================================
      // GUARDAR
      // ======================================================

      const fechaActual = new Date();

      await EquipoDb({
        familia: nomFamilia,
        tipo: nomTipo,
        marca: nomMarca,
        modelo: nomModelo,

        serie: ser,

        rfid: null,

        userAdd:
          user?.email || "",

        userMod:
          user?.email || "",

        fechaAdd:
          fechaActual,

        fechaMod:
          fechaActual,

        emp_id:
          users.emp_id,

        nomEntidad:
          users.empresa,

        status:
          "PREPARACION",
      });

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "exito",
        mensaje:
          "Equipo creado correctamente.",
      });

      /*
       * Dejamos las selecciones para ingresar
       * rápidamente otro dispositivo del mismo modelo.
       */
      setSerie("");

      setFlag((v) => !v);
    } catch (error) {
      console.error(
        "Error creando equipo:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible crear el equipo.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  // ==========================================================
  // EXPORTAR EXCEL
  // ==========================================================

  const ExportarXls = () => {
    if (equipo.length === 0) {
      return;
    }

    const columnsToShow = [
      "id",
      "familia",
      "tipo",
      "marca",
      "modelo",
      "serie",
      "rfid",
    ];

    const excelBlob = ExportarExcel(
      equipo,
      columnsToShow
    );

    const excelURL =
      URL.createObjectURL(
        excelBlob
      );

    const downloadLink =
      document.createElement(
        "a"
      );

    downloadLink.href =
      excelURL;

    downloadLink.download =
      "equipos.xlsx";

    document.body.appendChild(
      downloadLink
    );

    downloadLink.click();

    document.body.removeChild(
      downloadLink
    );

    URL.revokeObjectURL(
      excelURL
    );
  };

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <Container
      fluid
      style={{
        maxWidth: 1400,
        padding: "24px 28px",
        margin: "0 auto",
        background: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      {/* ==================================================== */}
      {/* ENCABEZADO */}
      {/* ==================================================== */}

      <div
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          alignItems: "center",
          marginBottom: 20,
          gap: 20,
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              minWidth: 48,
              borderRadius: 12,
              background: "#e5f7f7",
              display: "flex",
              alignItems: "center",
              justifyContent:
                "center",
            }}
          >
            <Icon
              name="heartbeat"
              style={{
                margin: 0,
                color: "#0d9da5",
                fontSize: 21,
              }}
            />
          </div>

          <div>
            <Header
              as="h2"
              style={{
                margin: 0,
                color: "#172b4d",
                fontSize: 24,
                fontWeight: 700,
              }}
            >
              Dispositivos Médicos
            </Header>

            <div
              style={{
                color: "#8793a5",
                fontSize: 13,
                marginTop: 4,
              }}
            >
              Registra y administra los dispositivos médicos de la empresa
            </div>
          </div>
        </div>

        <Button
          type="button"
          onClick={ExportarXls}
          disabled={
            equipo.length === 0
          }
          style={{
            background: "#ffffff",
            color: "#526273",
            border:
              "1px solid #d7dee7",
            borderRadius: 6,
            boxShadow: "none",
          }}
        >
          <Icon
            name="file excel outline"
            style={{
              color: "#21ba45",
            }}
          />

          Exportar Excel
        </Button>
      </div>

      {/* ==================================================== */}
      {/* CREAR EQUIPO */}
      {/* ==================================================== */}

      <Segment
        style={{
          borderRadius: 8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding: 0,
          background: "#ffffff",
          overflow: "visible",
          marginBottom: 14,
        }}
      >
        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display: "flex",
            alignItems: "center",
            gap: 9,
            color: "#253858",
            fontWeight: 600,
          }}
        >
          <Icon
            name="plus circle"
            style={{
              color: "#0d9da5",
            }}
          />

          Registrar dispositivo
        </div>

        <div
          style={{
            padding: 18,
          }}
        >
          <Form
            onSubmit={handleSubmit}
            size="small"
          >
            <div
              style={
                sectionTitleStyle
              }
            >
              <Icon name="sitemap" />
              Clasificación del dispositivo
            </div>

            <Form.Group
              widths="equal"
            >
              <Form.Field>
                <label>
                  Familia
                </label>

                <Dropdown
                  fluid
                  search
                  selection
                  placeholder="Seleccione Familia"
                  value={
                    nomFamilia || ""
                  }
                  onChange={(
                    e,
                    { value }
                  ) =>
                    cambiarFamilia(
                      value
                    )
                  }
                  options={
                    familiaOptions
                  }
                />
              </Form.Field>

              <Form.Field>
                <label>
                  Tipo
                </label>

                <Dropdown
                  fluid
                  search
                  selection
                  placeholder="Seleccione Tipo"
                  value={
                    nomTipo || ""
                  }
                  disabled={
                    !nomFamilia
                  }
                  onChange={(
                    e,
                    { value }
                  ) => {
                    setNomTipo(value);

                    sessionStorage.setItem(
                      "tipo",
                      value
                    );
                  }}
                  options={
                    tipoOptions
                  }
                />
              </Form.Field>

              <Form.Field>
                <label>
                  Marca
                </label>

                <Dropdown
                  fluid
                  search
                  selection
                  placeholder="Seleccione Marca"
                  value={
                    nomMarca || ""
                  }
                  onChange={(
                    e,
                    { value }
                  ) =>
                    cambiarMarca(
                      value
                    )
                  }
                  options={
                    marcaOptions
                  }
                />
              </Form.Field>

              <Form.Field>
                <label>
                  Modelo
                </label>

                <Dropdown
                  fluid
                  search
                  selection
                  placeholder="Seleccione Modelo"
                  value={
                    nomModelo || ""
                  }
                  disabled={
                    !nomMarca
                  }
                  onChange={(
                    e,
                    { value }
                  ) => {
                    setNomModelo(value);

                    sessionStorage.setItem(
                      "modelo",
                      value
                    );
                  }}
                  options={
                    modeloOptions
                  }
                />
              </Form.Field>
            </Form.Group>

            <div
              style={{
                ...sectionTitleStyle,
                marginTop: 18,
              }}
            >
              <Icon name="barcode" />
              Identificación
            </div>

            <div
              style={{
                display: "flex",
                alignItems:
                  "flex-end",
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  flex:
                    "1 1 300px",
                  maxWidth: 420,
                }}
              >
                <Form.Input
                  fluid
                  label="Número de Serie"
                  icon="barcode"
                  iconPosition="left"
                  placeholder="Ingrese N° de Serie"
                  value={serie}
                  onChange={(e) =>
                    setSerie(
                      e.target.value
                    )
                  }
                />
              </div>

              <Button
                type="submit"
                loading={
                  isSaving
                }
                disabled={
                  isSaving ||
                  !nomFamilia ||
                  !nomTipo ||
                  !nomMarca ||
                  !nomModelo ||
                  !serie.trim()
                }
                style={{
                  minWidth: 145,
                  height: 38,
                  marginBottom: 1,
                  background:
                    "#0d9da5",
                  color: "#ffffff",
                  border:
                    "1px solid #0d9da5",
                  borderRadius: 6,
                  boxShadow: "none",
                }}
              >
                {!isSaving && (
                  <Icon name="plus" />
                )}

                Crear Equipo
              </Button>
            </div>
          </Form>
        </div>
      </Segment>

      {/* ==================================================== */}
      {/* LISTADO */}
      {/* ==================================================== */}

      <Segment
        style={{
          borderRadius: 8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding: 0,
          background: "#ffffff",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            gap: 15,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              color: "#253858",
              fontWeight: 600,
            }}
          >
            <Icon
              name="list"
              style={{
                color: "#0d9da5",
              }}
            />

            Dispositivos registrados

            <span
              style={{
                marginLeft: 8,
                color: "#98a1af",
                fontSize: 11,
                fontWeight: 400,
              }}
            >
              {
                filteredEquipo.length
              }{" "}
              registros
            </span>
          </div>

          <div
            style={{
              width: 350,
              maxWidth: "100%",
            }}
          >
            <Input
              fluid
              icon="search"
              iconPosition="left"
              placeholder="Buscar equipo..."
              value={buscador}
              onChange={(e) =>
                setBuscador(
                  e.target.value
                )
              }
            />
          </div>
        </div>

        <div
          style={{
            maxHeight: 520,
            overflowY: "auto",
            overflowX: "auto",
          }}
        >
          <Table
            celled
            selectable
            compact
            unstackable
            style={{
              margin: 0,
              border: 0,
              borderRadius: 0,
              minWidth: 950,
              fontSize: 12,
            }}
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  width={1}
                  textAlign="center"
                  style={stickyTh}
                >
                  N°
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={4}
                  style={stickyTh}
                >
                  Familia
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={4}
                  style={stickyTh}
                >
                  Tipo
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={3}
                  style={stickyTh}
                >
                  Marca
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={3}
                  style={stickyTh}
                >
                  Modelo
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={3}
                  style={stickyTh}
                >
                  N° Serie
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {filteredEquipo.map(
                (item, index) => (
                  <Table.Row
                    key={item.id}
                  >
                    <Table.Cell
                      textAlign="center"
                    >
                      {index + 1}
                    </Table.Cell>

                    <Table.Cell>
                      <div
                        style={{
                          fontWeight:
                            600,
                          color:
                            "#344563",
                        }}
                      >
                        {item.familia ||
                          "-"}
                      </div>
                    </Table.Cell>

                    <Table.Cell>
                      {item.tipo || "-"}
                    </Table.Cell>

                    <Table.Cell>
                      {item.marca || "-"}
                    </Table.Cell>

                    <Table.Cell>
                      {item.modelo || "-"}
                    </Table.Cell>

                    <Table.Cell>
                      <span
                        style={{
                          fontFamily:
                            "monospace",
                          color:
                            "#344563",
                          fontWeight:
                            600,
                        }}
                      >
                        {item.serie || "-"}
                      </span>
                    </Table.Cell>
                  </Table.Row>
                )
              )}

              {filteredEquipo.length ===
                0 && (
                <Table.Row>
                  <Table.Cell
                    colSpan={6}
                    textAlign="center"
                    style={{
                      padding: 32,
                      color:
                        "#8995a3",
                    }}
                  >
                    <Icon name="search" />

                    No se encontraron dispositivos
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>

        {filteredEquipo.length >
          0 && (
          <div
            style={{
              padding:
                "12px 18px",
              borderTop:
                "1px solid #edf0f4",
              color: "#697586",
              fontSize: 12,
            }}
          >
            Mostrando{" "}
            <strong>
              {
                filteredEquipo.length
              }
            </strong>{" "}
            de{" "}
            <strong>
              {equipo.length}
            </strong>{" "}
            dispositivos
          </div>
        )}
      </Segment>

      <Alerta
        tipo={alerta.tipo}
        mensaje={alerta.mensaje}
        estadoAlerta={
          estadoAlerta
        }
        cambiarEstadoAlerta={
          cambiarEstadoAlerta
        }
      />
    </Container>
  );
};

const sectionTitleStyle = {
  color: "#344563",
  fontSize: 12,
  fontWeight: 700,
  marginBottom: 10,
  marginTop: 2,
  textTransform:
    "uppercase",
  letterSpacing:
    "0.3px",
};

const stickyTh = {
  position: "sticky",
  top: 0,
  zIndex: 2,
  background: "#f8fafc",
  color: "#344563",
  fontWeight: 600,
};

export default CrearEquipos;